
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91generic_93bs82wTcvdZMeta } from "/opt/build/repo/pages/[generic].vue?macro=true";
import { default as contactNfojXvLlAkMeta } from "/opt/build/repo/pages/contact.vue?macro=true";
import { default as indexlaFeZuYZkUMeta } from "/opt/build/repo/pages/index.vue?macro=true";
import { default as _91newsletter_934IcwYyMkVSMeta } from "/opt/build/repo/pages/news/[newsletter].vue?macro=true";
import { default as index8k4xMa35gmMeta } from "/opt/build/repo/pages/news/index.vue?macro=true";
import { default as privacy_45policyQXTlhFuZ55Meta } from "/opt/build/repo/pages/privacy-policy.vue?macro=true";
import { default as _91project_93RijH0RXLSmMeta } from "/opt/build/repo/pages/projects/[project].vue?macro=true";
import { default as indexxtMqaql9AYMeta } from "/opt/build/repo/pages/projects/index.vue?macro=true";
import { default as success5PxaWcwlslMeta } from "/opt/build/repo/pages/success.vue?macro=true";
import { default as _91team_93cvlCVkkAY5Meta } from "/opt/build/repo/pages/team/[team].vue?macro=true";
import { default as indexfyFJM7qkVcMeta } from "/opt/build/repo/pages/team/index.vue?macro=true";
import { default as component_45stubRU5sOBTecHMeta } from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubRU5sOBTecH } from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "generic___en",
    path: "/en/:generic()",
    component: () => import("/opt/build/repo/pages/[generic].vue")
  },
  {
    name: "generic___ja",
    path: "/:generic()",
    component: () => import("/opt/build/repo/pages/[generic].vue")
  },
  {
    name: "contact___en",
    path: "/en/contact",
    component: () => import("/opt/build/repo/pages/contact.vue")
  },
  {
    name: "contact___ja",
    path: "/contact",
    component: () => import("/opt/build/repo/pages/contact.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: "index___ja",
    path: "/",
    component: () => import("/opt/build/repo/pages/index.vue")
  },
  {
    name: "news-newsletter___en",
    path: "/en/news/:newsletter()",
    component: () => import("/opt/build/repo/pages/news/[newsletter].vue")
  },
  {
    name: "news-newsletter___ja",
    path: "/news/:newsletter()",
    component: () => import("/opt/build/repo/pages/news/[newsletter].vue")
  },
  {
    name: "news___en",
    path: "/en/news",
    component: () => import("/opt/build/repo/pages/news/index.vue")
  },
  {
    name: "news___ja",
    path: "/news",
    component: () => import("/opt/build/repo/pages/news/index.vue")
  },
  {
    name: "privacy-policy___en",
    path: "/en/privacy-policy",
    component: () => import("/opt/build/repo/pages/privacy-policy.vue")
  },
  {
    name: "privacy-policy___ja",
    path: "/privacy-policy",
    component: () => import("/opt/build/repo/pages/privacy-policy.vue")
  },
  {
    name: "projects-project___en",
    path: "/en/projects/:project()",
    component: () => import("/opt/build/repo/pages/projects/[project].vue")
  },
  {
    name: "projects-project___ja",
    path: "/projects/:project()",
    component: () => import("/opt/build/repo/pages/projects/[project].vue")
  },
  {
    name: "projects___en",
    path: "/en/projects",
    component: () => import("/opt/build/repo/pages/projects/index.vue")
  },
  {
    name: "projects___ja",
    path: "/projects",
    component: () => import("/opt/build/repo/pages/projects/index.vue")
  },
  {
    name: "success___en",
    path: "/en/success",
    component: () => import("/opt/build/repo/pages/success.vue")
  },
  {
    name: "success___ja",
    path: "/success",
    component: () => import("/opt/build/repo/pages/success.vue")
  },
  {
    name: "team-team___en",
    path: "/en/team/:team()",
    component: () => import("/opt/build/repo/pages/team/[team].vue")
  },
  {
    name: "team-team___ja",
    path: "/team/:team()",
    component: () => import("/opt/build/repo/pages/team/[team].vue")
  },
  {
    name: "team___en",
    path: "/en/team",
    component: () => import("/opt/build/repo/pages/team/index.vue")
  },
  {
    name: "team___ja",
    path: "/team",
    component: () => import("/opt/build/repo/pages/team/index.vue")
  },
  {
    name: component_45stubRU5sOBTecHMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubRU5sOBTecH
  }
]